/* eslint-disable */
import React, { useContext, useState } from 'react';
import { useNavigate, useParams, Link } from 'react-router-dom';
import { Grid, Paper, Button, Typography } from '@mui/material';
import {
  backLabelStyle,
  btnStyle,
  btnStyleActive,
  forgotHeaderStyle,
  h2Style,
  labelStyle,
  paperStyle,
  pLabelDarkerStyle,
  pLabelStyle,
  pStyle,
} from '../styles';
import { useValidCode } from '../../hooks/useValidCode';
import { AuthContext } from '../../contexts/authContext';
import ReactCodeInput from 'react-code-input';
import { Notif } from '../../components/Snackbar/Snackbar';
import { AuthPAGES } from '../../constants/pages';

const Pin: React.FC<any> = () => {
  /* States and context declaration */
  const { code, setCode, codeIsValid } = useValidCode('');
  const { email }: any = useParams();
  const authContext = useContext(AuthContext);

  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  /* Generic Error Message */
  const [genericErrorMessage, setGenericErrorMessage] = useState('');

  const onReSendCodeCallback = (isReSended: boolean) => {
    if (!isReSended) {
      setGenericErrorMessage('Ooops something was wrong please login again');
      setTimeout(function () {
        navigate(AuthPAGES.signIn);
      }, 4000);
    }
  };

  const onReSendCode = async (e: any) => {
    e.stopPropagation();

    if (authContext.mfaRequired)
      try {
        await authContext.reSendMfaCode(onReSendCodeCallback);
      } catch (error: any) {
        setGenericErrorMessage(error.message);
        setOpen(true);
      }
    else
      try {
        await authContext.reSendCode(email);
      } catch (error: any) {
        setGenericErrorMessage(error.message);
        setOpen(true);
      }
  };

  const sendCode = async (e: any) => {
    e.stopPropagation();

    if (code) {
      if (code.length === 0 || code.length > 6) {
        return;
      }
      if (authContext.mfaRequired)
        try {
          await authContext.sendMfaCode(email, code);
          setCode('');
          navigate(AuthPAGES.registerComplete);
        } catch (error: any) {
          setGenericErrorMessage(error.message);
          setOpen(true);
        }
      else
        try {
          await authContext.sendCode(email, code);
          setCode('');
          navigate(AuthPAGES.registerComplete);
        } catch (error: any) {
          setGenericErrorMessage(error.message);
          setOpen(true);
        }
    }
  };

  const isButtonDisabled = () => {
    return codeIsValid !== '';
  };

  return (
    <Grid
      container
      justifyContent='center'
      alignContent='center'
      style={{ display: 'flex', flexDirection: 'column' }}
    >
      <Grid item xl={3} lg={3} md={4} sm={6} xs={12}>
        <Paper elevation={0} style={paperStyle}>
          <Grid style={forgotHeaderStyle}>
            <h2 style={h2Style}>Enter PIN</h2>
            <p style={pStyle}>Please enter your security PIN code</p>
          </Grid>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ display: 'flex', justifyContent: 'space-evenly' }}
          >
            <ReactCodeInput
              type='text'
              fields={4}
              name='anyName'
              inputMode='tel'
              onChange={(e: any) => setCode(e)}
            />
          </Grid>
          <Grid item xs={12} md={12} xl={12} style={labelStyle}>
            <Typography style={pLabelDarkerStyle}>
              Forgot Your PIN?
              <Link to='' onClick={(e) => onReSendCode(e)} style={pLabelStyle}>
                Reset Pin
              </Link>
            </Typography>
          </Grid>
          <Button
            type='submit'
            color='primary'
            variant='contained'
            style={isButtonDisabled() ? btnStyle : btnStyleActive}
            fullWidth
            onClick={(e) => {
              sendCode(e);
            }}
            disabled={isButtonDisabled()}
          >
            Submit
          </Button>
          <Grid
            item
            xs={12}
            md={12}
            xl={12}
            style={{ ...backLabelStyle, marginTop: '48px' }}
          >
            <Link style={pLabelStyle} to='' onClick={(e: any) => navigate(-1)}>
              Back
            </Link>
          </Grid>
        </Paper>
      </Grid>
      <Notif open={open} setOpen={setOpen} message={genericErrorMessage} />
    </Grid>
  );
};

export default Pin;
